(function () {
  "use strict";

  // Microsoft Clarity — Pampas Mood
  // REQ-047: loads only once the visitor allows analytics (Shopify Customer Privacy API), never before a choice or after a refusal.
  var clarityLoaded = false;
  function loadClarity() {
    if (clarityLoaded) return;
    clarityLoaded = true;
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "y7v3m2sxzf");
  }
  function analyticsAllowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }
  // A visitor who withdraws analytics on the same page: Clarity is told consent is denied and stops recording.
  function stopClarity() {
    if (!clarityLoaded || typeof window.clarity !== "function") return;
    try { window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "denied" }); } catch (e) {}
    try { window.clarity("consent", false); } catch (e) {}
    try { window.clarity("stop"); } catch (e) {}
  }
  function startClarity() {
    if (!clarityLoaded) { loadClarity(); return; }
    try { window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "granted" }); } catch (e) {}
    try { window.clarity("start"); } catch (e) {}
  }
  function checkClarity() { if (analyticsAllowed()) startClarity(); else stopClarity(); }
  document.addEventListener("visitorConsentCollected", function (event) {
    if (event && event.detail && typeof event.detail.analyticsAllowed === "boolean") {
      if (event.detail.analyticsAllowed) startClarity(); else stopClarity();
    } else checkClarity();
  });
  function initConsent() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) { checkClarity(); return; }
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], function (error) {
          if (!error) checkClarity();
        });
      }
    } catch (e) {}
  }
  // This file runs at the top of <head>, before Shopify's own scripts, so the API is checked once the document is parsed.
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initConsent);
  else initConsent();

  // Hero banners are defined in sections/shoppable-hero.liquid.
  // Do not rewrite their images or links at runtime.

  // Preserve and load the original Maven CRM listener copied from this theme.
  var current = document.currentScript;
  if (!current || !current.src) return;

  try {
    var originalSrc = new URL(current.src);
    originalSrc.pathname = originalSrc.pathname.replace(/crm-webhook\.js$/, "crm-webhook-original.js");
    originalSrc.search = "";

    var originalScript = document.createElement("script");
    originalScript.src = originalSrc.toString();
    originalScript.async = false;
    current.parentNode.insertBefore(originalScript, current.nextSibling);
  } catch (error) {
    if (window.console) console.error("[pampas-clarity] Could not load original CRM listener", error);
  }
})();